import React from "react";

import { cn } from "@/lib/utils";

import { BrandMark } from "./brand-mark";

const SPINNER_SIZES = {
  sm: "h-5 w-5",
  md: "h-7 w-7",
  lg: "h-12 w-12",
  xl: "h-16 w-16",
} as const;

type BrandMarkSpinnerSize = keyof typeof SPINNER_SIZES;

type BrandMarkSpinnerProps = {
  className?: string;
  size?: BrandMarkSpinnerSize;
  testId?: string;
};

export function BrandMarkSpinner({ className, size = "md", testId = "brand-mark-spinner" }: BrandMarkSpinnerProps) {
  return (
    <div className={cn("relative shrink-0", SPINNER_SIZES[size], className)} data-testid={testId} role="status">
      <div
        aria-hidden="true"
        className="brand-mark-spinner-glow absolute -inset-[18%] rounded-[1.35rem] bg-[radial-gradient(circle,rgb(var(--nice-gold-light-rgb)/0.45)_0%,transparent_72%)]"
      />
      <div
        aria-hidden="true"
        className="brand-mark-spinner-orbit absolute inset-0 rounded-[28%] bg-[conic-gradient(from_90deg,transparent_0deg,rgb(var(--nice-gold-rgb)/0.08)_40deg,#ffc83c_130deg,#ffdd87_210deg,transparent_320deg)]"
      />
      <div
        aria-hidden="true"
        className="brand-mark-spinner-orbit-reverse absolute inset-[1px] rounded-[27%] bg-[conic-gradient(from_270deg,transparent_0deg,rgb(var(--nice-gold-light-rgb)/0.2)_80deg,#fff6e4_160deg,transparent_280deg)] opacity-70"
      />
      <div className="absolute inset-[15%] overflow-hidden rounded-[22%] shadow-elevation1 ring-1 ring-[rgb(var(--nice-gold-light-rgb)/0.2)]">
        <BrandMark animated={false} compact testId={`${testId}-mark`} />
      </div>
    </div>
  );
}
